import { getGameKeys } from "./sidebar/sameGameCorrelation";

export const WIN_100_PARAM = "ww_win_100";
export const WIN_100_PICK_COUNT = 4;
export const WIN_100_HIT_4_PAYOUT = 100;
export const WIN_100_HIT_3_PAYOUT = 10;
export const WIN_100_SELECTED_STORAGE_KEY = "ww_win_100_selected";

const isTruthyParam = (value) => ["1", "true", "yes", "on"].includes(
  String(value || "").trim().toLowerCase()
);

export const isWin100ModeActive = (search = null) => {
  const query = search === null
    ? (typeof window !== "undefined" ? window.location.search : "")
    : search;

  return isTruthyParam(new URLSearchParams(query || "").get(WIN_100_PARAM));
};

const getAthleteKey = (selection) => {
  const athleteId = selection?.athlete_id ?? selection?.athleteId ?? selection?.participant_id;
  if (athleteId !== undefined && athleteId !== null && String(athleteId).trim() !== "") {
    return `id:${String(athleteId).trim()}`;
  }

  const name = String(selection?.name || selection?.athlete_name || "").trim().toLowerCase();
  return name ? `name:${name}` : "";
};

export const getWin100LineupViolation = (selected = []) => {
  const selections = Array.isArray(selected) ? selected : [];

  if (selections.length > WIN_100_PICK_COUNT) {
    return {
      code: "win_100_pick_limit",
      title: "Win $100",
      message: `The Win $100 line-up is limited to exactly ${WIN_100_PICK_COUNT} picks.`,
    };
  }

  const athleteKeys = selections.map(getAthleteKey);
  if (athleteKeys.some((key) => !key)) {
    return {
      code: "win_100_missing_athlete",
      title: "Choose another athlete",
      message: "Every Win $100 pick must identify a unique athlete.",
    };
  }
  if (new Set(athleteKeys).size !== athleteKeys.length) {
    return {
      code: "win_100_duplicate_athlete",
      title: "Choose another athlete",
      message: "Win $100 requires 4 unique athletes. Choose a different athlete for this pick.",
    };
  }

  const gameKeys = getGameKeys(selections);
  if (gameKeys.some((key) => !key)) {
    return {
      code: "win_100_missing_event",
      title: "Choose another event",
      message: "This pick is missing event details and cannot be used for Win $100.",
    };
  }
  if (new Set(gameKeys).size !== gameKeys.length) {
    return {
      code: "win_100_same_event",
      title: "Choose another event",
      message: "Win $100 allows only one pick from each game or event.",
    };
  }

  return null;
};

export const getWin100CheckoutWarning = (selected = []) => {
  const selections = Array.isArray(selected) ? selected : [];
  const violation = getWin100LineupViolation(selections);
  if (violation) {
    return { ...violation, blocking: true, tone: "warning" };
  }

  if (selections.length !== WIN_100_PICK_COUNT) {
    const picksNeeded = WIN_100_PICK_COUNT - selections.length;
    return {
      code: "win_100_exact_pick_count",
      title: "Win $100",
      message: picksNeeded > 0
        ? `Add ${picksNeeded} more pick${picksNeeded === 1 ? "" : "s"} from different events to continue.`
        : `Win $100 requires exactly ${WIN_100_PICK_COUNT} picks.`,
      blocking: true,
      tone: "info",
    };
  }

  return null;
};

export const getWin100RewardPayout = (selected = []) => (
  getWin100CheckoutWarning(selected) === null
    ? WIN_100_HIT_4_PAYOUT
    : null
);

export const filterWin100CompatibleSelections = (selected = []) => (
  (Array.isArray(selected) ? selected : []).reduce((compatible, selection) => {
    const candidate = [...compatible, selection];
    return !getWin100LineupViolation(candidate) ? candidate : compatible;
  }, [])
);
